export const baseConfig = {
  horizontalGap: 'gap-2.5',
  verticalGap: 'gap-1',
  horizontalPadding: 'px-3.5',
  verticalPadding: 'py-2.5',
  rounding: 'rounded-lg',
  leading: 'leading-6',
  subLeading: 'leading-4',
}

export const smallConfig = {
  horizontalGap: 'gap-2',
  verticalGap: 'gap-1',
  horizontalPadding: 'px-3',
  verticalPadding: 'py-2',
  rounding: 'rounded-lg',
  leading: 'leading-5',
  subLeading: 'leading-3',
}

export const insetBorder =
  'ring-1 ring-inset ring-gray-300 dark:ring-inset dark:ring-gray-700'
